import './mobile_menu_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['title']

  open () {
    this.element.classList.add('mobile_menu--opened')
    this.bodyElement.classList.add('body--open_menu')
  }

  close () {
    this.element.classList.remove('mobile_menu--opened')
    this.bodyElement.classList.remove('body--open_menu')
  }

  switchCategoryType (categoryType) {
    this.titleTargets.map((title) => {
      if (title.classList.contains(categoryType)) {
        title.classList.add('mobile_menu-title--selected')
      } else {
        title.classList.remove('mobile_menu-title--selected')
      }
    })

    this.categoryListControllers.map((controller) => {
      if (controller.categoryType === categoryType) {
        controller.show()
      } else {
        controller.hide()
      }
    })
  }

  get bodyElement () {
    return document.body
  }

  get categoryListControllers () {
    return this.application.controllers.filter(controller => {
      return controller.context.identifier === 'category-list'
    })
  }
}
